import React from "react";

const ProcessPaymentIcon = (props: any) => {
  return (
    <svg width={20} height={20} fill="none" {...props}>
      <path
        stroke="var(--color-blue)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M1.667 7.082h10.416M5 13.75h1.667M8.75 13.75h3.333"
      />
      <path
        stroke="var(--color-blue)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M18.333 11.693v1.733c0 2.925-.741 3.659-3.7 3.659H5.367c-2.959 0-3.7-.734-3.7-3.659v-6.85c0-2.925.741-3.658 3.7-3.658h6.716M16.666 7.918v-5l1.667 1.667M16.667 2.918 15 4.585"
      />
    </svg>
  );
};

export default ProcessPaymentIcon;
